import { render, staticRenderFns } from "./ydfx.vue?vue&type=template&id=3d4a8f3e&"
import script from "./ydfx.vue?vue&type=script&lang=js&"
export * from "./ydfx.vue?vue&type=script&lang=js&"
import style0 from "./ydfx.vue?vue&type=style&index=0&id=3d4a8f3e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports